<template>
  <main class="main">
    <card title="Test" cols="4">
      <hm-input-multilang v-model="data" :system-languages="true" label="Test" />
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import fecha from 'fecha';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy, keyBy, keys, mapValues, map, first, last } from 'lodash';
import HmCardInner from './lib/layout/HmCardInner';
import HmInputMoney from './lib/inputs/HmInputMoney';
import SaveWatchMixin from '../mixins/SaveWatchMixin';
import SeasonCalendar from './lib/calendar/SeasonCalendar';
import BaseHmInput from './lib/inputs/BaseHmInput';
import HmInputToggle from './lib/inputs/HmInputToggle';
import HmInputRate from './lib/inputs/HmInputRate';
import RoomTypeSeasonRateEditor from './lib/seasonRateEditor/RoomTypeSeasonRateEditor';
import HmInputNumber from './lib/inputs/HmInputNumber';
import HmInputCheckbox from './lib/inputs/HmInputCheckbox';

export default {
  name: 'Dashboard',
  components: { HmInputCheckbox, HmInputToggle, HmInputNumber, RoomTypeSeasonRateEditor, HmInputRate, HmCardInner },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
  ],

  data() {
    return {
      data: {
        de: 'Mein Text',
        en: null,
        es: 'Hola!',
      },
    };
  },

  computed: {
  },

  watch: {
  },

  created: function () {
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue